if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor () {
        super()

        this.form = this.querySelector('form')
        this.submitButton = this.querySelector('[type="submit"]')
        this.submitButtonLoader = this.querySelector(
          '.product-details-action-button-loader'
        )
        // Event listener
        this.form.addEventListener('submit', (e) => {
          e.preventDefault()
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return
          const config = fetchConfig('javascript')
          config.headers['X-Requested-With'] = 'XMLHttpRequest'
          delete config.headers['Content-Type']

          const formData = new FormData(this.form)
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            )
            formData.append('sections_url', window.location.pathname)
            this.cart.setActiveElement(document.activeElement)
          }
          config.body = formData

          this.submitButton.disabled = true
          this.submitButton.classList.add('loading')
          this.submitButtonLoader.classList.add('loading')

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                const data = {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message
                }

                // Add Error message
                const navErrors = document.querySelector('.nav-errors')
                navErrors.classList.add('show')
                navErrors.innerHTML = response.errors || response.description
                setTimeout(() => {
                  navErrors.innerHTML = ''
                  navErrors.classList.remove('show')
                }, 3000)

                this.error = true
                return
              }
              if (!this.error) {
                fetch(`${routes.cart_url}`, config)
                  .then((response) => response.json())
                  .then((response) => {
                    document.querySelector(
                      '.cart-count-bubble'
                    ).innerHTML = `(${response.item_count})`
                  })
              }
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              // Remove the loader
              this.submitButton.disabled = false
              this.submitButtonLoader.classList.remove('loading')
              this.submitButton.classList.remove('loading')
            })
        })
      }

      get variantIdInput () {
        return this.form.querySelector('[name=id]')
      }
    }
  )
}
